"use client";

import { c as _c } from "react/compiler-runtime";
import { FormEvent, useContext, useEffect, useState } from "react";
import { ApiProfileRaterCicState } from "@/entities/IProfile";
import { getStringAsNumberOrZero } from "@/helpers/Helpers";
import { AuthContext } from "@/components/auth/Auth";
import { commonApiFetch, commonApiPost } from "@/services/api/common-api";
import { useMutation, useQuery } from "@tanstack/react-query";
import { QueryKey, ReactQueryWrapperContext } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { createBreakpoint } from "react-use";
import UserRateAdjustmentHelper from "@/components/user/utils/rate/UserRateAdjustmentHelper";
import CircleLoader from "@/components/distribution-plan-tool/common/CircleLoader";
import { ApiProfileProxyActionType } from "@/generated/models/ApiProfileProxyActionType";
import UserPageIdentityHeaderCICRateStats from "./UserPageIdentityHeaderCICRateStats";
import { useSeizeConnectContext } from "@/components/auth/SeizeConnectContext";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
const useBreakpoint = createBreakpoint({
  MD: 768,
  S: 0
});
export default function UserPageIdentityHeaderCICRate(t0) {
  const $ = _c(143);
  const {
    profile,
    isTooltip
  } = t0;
  const {
    address
  } = useSeizeConnectContext();
  const {
    requestAuth,
    setToast,
    connectedProfile,
    activeProfileProxy
  } = useContext(AuthContext);
  const {
    onProfileCICModify
  } = useContext(ReactQueryWrapperContext);
  let t1;
  if ($[0] !== profile.handle) {
    t1 = profile?.handle?.toLowerCase();
    $[0] = profile.handle;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== activeProfileProxy?.created_by.handle || $[3] !== address) {
    t2 = activeProfileProxy?.created_by.handle ?? address?.toLowerCase();
    $[2] = activeProfileProxy?.created_by.handle;
    $[3] = address;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = [QueryKey.PROFILE_RATER_CIC_STATE, {
      handle: t1,
      rater: t2
    }];
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== activeProfileProxy?.created_by || $[9] !== address || $[10] !== profile.query) {
    t4 = async () => await commonApiFetch({
      endpoint: `profiles/${profile.query}/cic/rating/${activeProfileProxy?.created_by.handle ?? address?.toLowerCase()}`
    });
    $[8] = activeProfileProxy?.created_by;
    $[9] = address;
    $[10] = profile.query;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const t5 = !!address;
  let t6;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = {
      queryKey: t3,
      queryFn: t4,
      enabled: t5,
      staleTime: 0
    };
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const {
    data: currentCICState
  } = useQuery(t6);
  const [mutating, setMutating] = useState(false);
  let t7;
  if ($[16] !== profile.query) {
    t7 = async amount => {
      setMutating(true);
      return await commonApiPost({
        endpoint: `profiles/${profile.query}/cic/rating`,
        body: {
          amount
        }
      });
    };
    $[16] = profile.query;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== activeProfileProxy || $[19] !== address || $[20] !== connectedProfile || $[21] !== onProfileCICModify || $[22] !== profile || $[23] !== setToast) {
    t8 = () => {
      setToast({
        message: "NIC rating updated.",
        type: "success"
      });
      onProfileCICModify({
        targetProfile: profile,
        connectedProfile: connectedProfile ?? null,
        rater: activeProfileProxy?.created_by.handle ?? address?.toLowerCase() ?? null,
        profileProxy: activeProfileProxy ?? null
      });
    };
    $[18] = activeProfileProxy;
    $[19] = address;
    $[20] = connectedProfile;
    $[21] = onProfileCICModify;
    $[22] = profile;
    $[23] = setToast;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      setMutating(false);
    };
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t7 || $[27] !== t8) {
    t10 = {
      mutationFn: t7,
      onSuccess: t8,
      onSettled: t9
    };
    $[26] = t7;
    $[27] = t8;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  const updateCICMutation = useMutation(t10);
  let t11;
  if ($[29] !== activeProfileProxy?.actions) {
    t11 = () => {
      const repProxy = activeProfileProxy?.actions.find(_temp);
      if (!repProxy) {
        return null;
      }
      return Math.max((repProxy.credit_amount ?? 0) - (repProxy.credit_spent ?? 0), 0);
    };
    $[29] = activeProfileProxy?.actions;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  const getProxyAvailableCredit = t11;
  const [proxyAvailableCredit, setProxyAvailableCredit] = useState(getProxyAvailableCredit());
  let t12;
  if ($[31] !== getProxyAvailableCredit) {
    t12 = () => setProxyAvailableCredit(getProxyAvailableCredit());
    $[31] = getProxyAvailableCredit;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== activeProfileProxy) {
    t13 = [activeProfileProxy];
    $[33] = activeProfileProxy;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  useEffect(t12, t13);
  let t14;
  if ($[35] !== currentCICState?.cic_rating_by_rater || $[36] !== currentCICState?.cic_ratings_left_to_give_by_rater || $[37] !== proxyAvailableCredit) {
    t14 = () => {
      const currentCic = currentCICState?.cic_rating_by_rater ?? 0;
      const heroAvailableCic = currentCICState?.cic_ratings_left_to_give_by_rater ?? 0;
      const minHeroCic = 0 - (Math.abs(currentCic) + heroAvailableCic);
      if (typeof proxyAvailableCredit !== "number") {
        return minHeroCic;
      }
      const minProxyRep = currentCic - proxyAvailableCredit;
      return Math.abs(minHeroCic) < Math.abs(minProxyRep) ? minHeroCic : minProxyRep;
    };
    $[35] = currentCICState?.cic_rating_by_rater;
    $[36] = currentCICState?.cic_ratings_left_to_give_by_rater;
    $[37] = proxyAvailableCredit;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  const getMinValue = t14;
  let t15;
  if ($[39] !== currentCICState?.cic_rating_by_rater || $[40] !== currentCICState?.cic_ratings_left_to_give_by_rater || $[41] !== proxyAvailableCredit) {
    t15 = () => {
      const currentCic_0 = currentCICState?.cic_rating_by_rater ?? 0;
      const heroAvailableCic_0 = currentCICState?.cic_ratings_left_to_give_by_rater ?? 0;
      const maxHeroCic = Math.abs(currentCic_0) + heroAvailableCic_0;
      if (typeof proxyAvailableCredit !== "number") {
        return maxHeroCic;
      }
      const maxProxyRep = currentCic_0 + proxyAvailableCredit;
      return Math.min(maxHeroCic, maxProxyRep);
    };
    $[39] = currentCICState?.cic_rating_by_rater;
    $[40] = currentCICState?.cic_ratings_left_to_give_by_rater;
    $[41] = proxyAvailableCredit;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  const getMaxValue = t15;
  let t16;
  if ($[43] !== getMaxValue || $[44] !== getMinValue) {
    t16 = () => ({
      min: getMinValue(),
      max: getMaxValue()
    });
    $[43] = getMaxValue;
    $[44] = getMinValue;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  const getMinMaxValues = t16;
  let t17;
  if ($[46] !== getMinMaxValues) {
    t17 = getMinMaxValues();
    $[46] = getMinMaxValues;
    $[47] = t17;
  } else {
    t17 = $[47];
  }
  const [minMaxValues, setMinMaxValues] = useState(t17);
  let t18;
  if ($[48] !== getMinMaxValues) {
    t18 = () => setMinMaxValues(getMinMaxValues());
    $[48] = getMinMaxValues;
    $[49] = t18;
  } else {
    t18 = $[49];
  }
  let t19;
  if ($[50] !== currentCICState || $[51] !== proxyAvailableCredit) {
    t19 = [currentCICState, proxyAvailableCredit];
    $[50] = currentCICState;
    $[51] = proxyAvailableCredit;
    $[52] = t19;
  } else {
    t19 = $[52];
  }
  useEffect(t18, t19);
  const [originalRating, setOriginalRating] = useState(currentCICState?.cic_rating_by_rater ?? 0);
  const [adjustedRatingStr, setAdjustedRatingStr] = useState(`${originalRating}`);
  const getValueStr = _temp2;
  let t20;
  if ($[53] !== currentCICState?.cic_rating_by_rater) {
    t20 = () => {
      setOriginalRating(currentCICState?.cic_rating_by_rater ?? 0);
      setAdjustedRatingStr(`${currentCICState?.cic_rating_by_rater ?? 0}`);
    };
    $[53] = currentCICState?.cic_rating_by_rater;
    $[54] = t20;
  } else {
    t20 = $[54];
  }
  let t21;
  if ($[55] !== currentCICState) {
    t21 = [currentCICState];
    $[55] = currentCICState;
    $[56] = t21;
  } else {
    t21 = $[56];
  }
  useEffect(t20, t21);
  let t22;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = e => {
      const inputValue = e.currentTarget.value;
      const strCIC_0 = ["-0", "0-"].includes(inputValue) ? "-" : inputValue;
      if (/^-?\d*$/.test(strCIC_0)) {
        const newCicValue = getValueStr(strCIC_0);
        setAdjustedRatingStr(newCicValue);
      }
    };
    $[57] = t22;
  } else {
    t22 = $[57];
  }
  const onValueChange = t22;
  let t23;
  if ($[58] !== adjustedRatingStr || $[59] !== getMinMaxValues) {
    t23 = () => {
      const {
        min,
        max
      } = getMinMaxValues();
      const valueAsNumber = getStringAsNumberOrZero(adjustedRatingStr);
      if (valueAsNumber > max) {
        setAdjustedRatingStr(`${max}`);
        return;
      }
      if (valueAsNumber < min) {
        setAdjustedRatingStr(`${min}`);
      }
    };
    $[58] = adjustedRatingStr;
    $[59] = getMinMaxValues;
    $[60] = t23;
  } else {
    t23 = $[60];
  }
  const adjustStrValueToMinMax = t23;
  let t24;
  if ($[61] !== adjustedRatingStr || $[62] !== minMaxValues) {
    t24 = () => {
      const {
        min: min_0,
        max: max_0
      } = minMaxValues;
      const valueAsNumber_0 = getStringAsNumberOrZero(adjustedRatingStr);
      if (valueAsNumber_0 > max_0) {
        return false;
      }
      if (valueAsNumber_0 < min_0) {
        return false;
      }
      return true;
    };
    $[61] = adjustedRatingStr;
    $[62] = minMaxValues;
    $[63] = t24;
  } else {
    t24 = $[63];
  }
  const getIsValidValue = t24;
  const [isValidValue, setIsValidValue] = useState(getIsValidValue());
  let t25;
  if ($[64] !== getIsValidValue) {
    t25 = () => setIsValidValue(getIsValidValue());
    $[64] = getIsValidValue;
    $[65] = t25;
  } else {
    t25 = $[65];
  }
  let t26;
  if ($[66] !== adjustedRatingStr) {
    t26 = [adjustedRatingStr];
    $[66] = adjustedRatingStr;
    $[67] = t26;
  } else {
    t26 = $[67];
  }
  useEffect(t25, t26);
  let t27;
  if ($[68] !== adjustedRatingStr) {
    t27 = getStringAsNumberOrZero(adjustedRatingStr);
    $[68] = adjustedRatingStr;
    $[69] = t27;
  } else {
    t27 = $[69];
  }
  const [newRating, setNewRating] = useState(t27);
  let t28;
  let t29;
  if ($[70] !== adjustedRatingStr) {
    t28 = () => {
      setNewRating(getStringAsNumberOrZero(adjustedRatingStr));
    };
    t29 = [adjustedRatingStr];
    $[70] = adjustedRatingStr;
    $[71] = t28;
    $[72] = t29;
  } else {
    t28 = $[71];
    t29 = $[72];
  }
  useEffect(t28, t29);
  const [haveChanged, setHaveChanged] = useState(newRating !== originalRating);
  let t30;
  let t31;
  if ($[73] !== newRating || $[74] !== originalRating) {
    t30 = () => {
      setHaveChanged(newRating !== originalRating);
    };
    t31 = [newRating, originalRating];
    $[73] = newRating;
    $[74] = originalRating;
    $[75] = t30;
    $[76] = t31;
  } else {
    t30 = $[75];
    t31 = $[76];
  }
  useEffect(t30, t31);
  let t32;
  if ($[77] !== haveChanged || $[78] !== isValidValue) {
    t32 = () => {
      if (!haveChanged) {
        return true;
      }
      if (!isValidValue) {
        return true;
      }
      return false;
    };
    $[77] = haveChanged;
    $[78] = isValidValue;
    $[79] = t32;
  } else {
    t32 = $[79];
  }
  const getIsSaveDisabled = t32;
  const [isSaveDisabled, setIsSaveDisabled] = useState(getIsSaveDisabled());
  let t33;
  if ($[80] !== getIsSaveDisabled) {
    t33 = () => {
      setIsSaveDisabled(getIsSaveDisabled());
    };
    $[80] = getIsSaveDisabled;
    $[81] = t33;
  } else {
    t33 = $[81];
  }
  let t34;
  if ($[82] !== haveChanged || $[83] !== isValidValue) {
    t34 = [haveChanged, isValidValue];
    $[82] = haveChanged;
    $[83] = isValidValue;
    $[84] = t34;
  } else {
    t34 = $[84];
  }
  useEffect(t33, t34);
  let t35;
  if ($[85] !== haveChanged || $[86] !== isValidValue || $[87] !== newRating || $[88] !== requestAuth || $[89] !== setToast || $[90] !== updateCICMutation) {
    const onSave = async () => {
      const {
        success
      } = await requestAuth();
      if (!success) {
        setToast({
          message: "You must be logged in.",
          type: "error"
        });
        return;
      }
      if (!haveChanged || !isValidValue) {
        return;
      }
      await updateCICMutation.mutateAsync(newRating);
    };
    t35 = async e_0 => {
      e_0.preventDefault();
      await onSave();
    };
    $[85] = haveChanged;
    $[86] = isValidValue;
    $[87] = newRating;
    $[88] = requestAuth;
    $[89] = setToast;
    $[90] = updateCICMutation;
    $[91] = t35;
  } else {
    t35 = $[91];
  }
  const onSubmit = t35;
  const breakpoint = useBreakpoint();
  const t36 = `${isTooltip ? "" : "tw-bg-iron-950 tw-px-4 tw-py-6 lg:tw-p-8 tw-rounded-xl tw-border tw-border-solid tw-border-iron-800"} `;
  const t37 = currentCICState?.cic_ratings_left_to_give_by_rater ?? 0;
  let t38;
  if ($[92] !== isTooltip || $[93] !== minMaxValues || $[94] !== profile || $[95] !== t37) {
    t38 = <UserPageIdentityHeaderCICRateStats isTooltip={isTooltip} profile={profile} minMaxValues={minMaxValues} heroAvailableCredit={t37} />;
    $[92] = isTooltip;
    $[93] = minMaxValues;
    $[94] = profile;
    $[95] = t37;
    $[96] = t38;
  } else {
    t38 = $[96];
  }
  const t39 = `${isTooltip ? "tw-mt-4" : "tw-mt-6"}`;
  const t40 = `${isTooltip ? "" : "tw-flex-wrap"} tw-flex tw-items-end tw-gap-3`;
  const t41 = `${isTooltip ? "tw-max-w-[12rem]" : "tw-w-full sm:tw-w-auto"} tw-block tw-text-sm tw-font-normal tw-text-iron-200`;
  let t42;
  if ($[97] !== profile.query) {
    t42 = <span className="tw-whitespace-nowrap">{profile.query}:</span>;
    $[97] = profile.query;
    $[98] = t42;
  } else {
    t42 = $[98];
  }
  let t43;
  if ($[99] !== t41 || $[100] !== t42) {
    t43 = <label htmlFor="nic-rating-input" className={t41}>Your total NIC Rating of{" "}{t42}</label>;
    $[99] = t41;
    $[100] = t42;
    $[101] = t43;
  } else {
    t43 = $[101];
  }
  let t44;
  if ($[102] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = <svg className="tw-w-3.5 tw-h-3.5 tw-flex-shrink-0 tw-text-iron-500" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[102] = t44;
  } else {
    t44 = $[102];
  }
  let t45;
  if ($[103] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = <span className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-bg-iron-800 tw-rounded-l-lg tw-border tw-border-solid tw-border-iron-800 tw-px-3">{t44}<svg className="tw-w-3.5 tw-h-3.5 tw-flex-shrink-0 tw-text-iron-500" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 12H19" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" /></svg></span>;
    $[103] = t45;
  } else {
    t45 = $[103];
  }
  const t46 = `${isTooltip ? "tw-max-w-[12rem]" : "tw-w-full sm:tw-w-auto"} -tw-ml-0.5 tw-appearance-none tw-block tw-rounded-l-none tw-rounded-r-lg tw-border-0 tw-ring-1 tw-ring-inset tw-ring-iron-700 tw-py-3 tw-px-3 tw-bg-iron-900 focus:tw-bg-iron-950 tw-text-iron-100 tw-font-medium tw-caret-primary-400 tw-shadow-sm hover:tw-ring-iron-600 placeholder:tw-text-iron-500 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400 tw-text-base tw-transition tw-duration-300 tw-ease-out`;
  let t47;
  if ($[104] !== adjustStrValueToMinMax || $[105] !== adjustedRatingStr || $[106] !== t46) {
    t47 = <div className="tw-w-full tw-relative tw-flex tw-mt-1.5">{t45}<input type="text" id="nic-rating-input" value={adjustedRatingStr} onChange={onValueChange} onBlur={adjustStrValueToMinMax} required={true} autoComplete="off" className={t46} /></div>;
    $[104] = adjustStrValueToMinMax;
    $[105] = adjustedRatingStr;
    $[106] = t46;
    $[107] = t47;
  } else {
    t47 = $[107];
  }
  let t48;
  if ($[108] !== t43 || $[109] !== t47) {
    t48 = <div className="tw-w-full sm:tw-w-auto">{t43}{t47}</div>;
    $[108] = t43;
    $[109] = t47;
    $[110] = t48;
  } else {
    t48 = $[110];
  }
  const t49 = `${!isSaveDisabled ? "hover:tw-bg-primary-600 hover:tw-border-primary-600" : "tw-cursor-not-allowed tw-opacity-50"} tw-w-full sm:tw-w-auto  tw-bg-primary-500 tw-px-4 tw-py-3 tw-text-sm tw-font-semibold tw-text-white 
              tw-border tw-border-solid tw-border-primary-500 tw-rounded-lg  tw-transition tw-duration-300 tw-ease-out`;
  let t50;
  if ($[111] !== mutating) {
    t50 = mutating ? <div className="tw-w-8"><CircleLoader /></div> : <>Rate</>;
    $[111] = mutating;
    $[112] = t50;
  } else {
    t50 = $[112];
  }
  let t51;
  if ($[113] !== isSaveDisabled || $[114] !== t49 || $[115] !== t50) {
    t51 = <button type="submit" disabled={isSaveDisabled} className={t49}>{t50}</button>;
    $[113] = isSaveDisabled;
    $[114] = t49;
    $[115] = t50;
    $[116] = t51;
  } else {
    t51 = $[116];
  }
  let t52;
  if ($[117] !== adjustedRatingStr || $[118] !== breakpoint || $[119] !== isTooltip || $[120] !== originalRating) {
    t52 = !isTooltip && breakpoint === "MD" && <UserRateAdjustmentHelper inLineValues={isTooltip} originalValue={originalRating} adjustedValue={getStringAsNumberOrZero(adjustedRatingStr)} adjustmentType="NIC" />;
    $[117] = adjustedRatingStr;
    $[118] = breakpoint;
    $[119] = isTooltip;
    $[120] = originalRating;
    $[121] = t52;
  } else {
    t52 = $[121];
  }
  let t53;
  if ($[122] !== t51 || $[123] !== t52) {
    t53 = <div className="tw-w-full sm:tw-w-auto"><div className="tw-w-full sm:tw-w-auto tw-inline-flex tw-items-end tw-space-x-6">{t51}{t52}</div></div>;
    $[122] = t51;
    $[123] = t52;
    $[124] = t53;
  } else {
    t53 = $[124];
  }
  let t54;
  if ($[125] !== t40 || $[126] !== t48 || $[127] !== t53) {
    t54 = <div className={t40}>{t48}{t53}</div>;
    $[125] = t40;
    $[126] = t48;
    $[127] = t53;
    $[128] = t54;
  } else {
    t54 = $[128];
  }
  let t55;
  if ($[129] !== adjustedRatingStr || $[130] !== breakpoint || $[131] !== isTooltip || $[132] !== originalRating) {
    t55 = !!(isTooltip || breakpoint !== "MD") && <UserRateAdjustmentHelper inLineValues={isTooltip} originalValue={originalRating} adjustedValue={getStringAsNumberOrZero(adjustedRatingStr)} adjustmentType="NIC" />;
    $[129] = adjustedRatingStr;
    $[130] = breakpoint;
    $[131] = isTooltip;
    $[132] = originalRating;
    $[133] = t55;
  } else {
    t55 = $[133];
  }
  let t56;
  if ($[134] !== onSubmit || $[135] !== t39 || $[136] !== t54 || $[137] !== t55) {
    t56 = <form onSubmit={onSubmit} className={t39}>{t54}{t55}</form>;
    $[134] = onSubmit;
    $[135] = t39;
    $[136] = t54;
    $[137] = t55;
    $[138] = t56;
  } else {
    t56 = $[138];
  }
  let t57;
  if ($[139] !== t36 || $[140] !== t38 || $[141] !== t56) {
    t57 = <div className={t36}>{t38}{t56}</div>;
    $[139] = t36;
    $[140] = t38;
    $[141] = t56;
    $[142] = t57;
  } else {
    t57 = $[142];
  }
  return t57;
}
function _temp2(strCIC) {
  if (strCIC.length > 1 && strCIC.startsWith("0")) {
    return strCIC.slice(1);
  }
  return strCIC;
}
function _temp(a) {
  return a.action_type === ApiProfileProxyActionType.AllocateCic;
}